import { Link } from 'react-router';
import { Mark } from '../../ui/Mark';
import { landing } from '../../copy/landing';
import { nav } from '../../copy/shell';
import { NavItems } from './NavItems';
import { NavFooter } from './NavFooter';
import s from './SideNav.module.css';

export function SideNav({ onNavigate }: { onNavigate?: () => void }) {
  return (
    <nav className={s.sideNav} aria-label={nav.primary}>
      <Link to="/overview" className={s.masthead}>
        <Mark size={22} />
        <span className={s.wordmark}>{landing.wordmark}</span>
      </Link>

      <NavItems {...(onNavigate ? { onNavigate } : {})} />

      <div className={s.footer}>
        <NavFooter />
      </div>
    </nav>
  );
}

export default SideNav;
